import {boostStore} from '@/entities/boost';

export function clearMyBoostHandler() {
  boostStore.setMyBoost(undefined);
}
